import { render, staticRenderFns } from "./client-form-add.vue?vue&type=template&id=420a0f88&scoped=true"
import script from "./client-form-add.vue?vue&type=script&lang=js"
export * from "./client-form-add.vue?vue&type=script&lang=js"
import style0 from "./client-form-add.vue?vue&type=style&index=0&id=420a0f88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420a0f88",
  null
  
)

export default component.exports